export default __webpack_public_path__ + "static/media/bra-arte-4.3f2d763e.webp";